import { createContext } from "react";
const GroupContext = createContext(null);
export { GroupContext };
//# sourceMappingURL=GroupContext.mjs.map
